import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import DefaultPage from '../baseComponents/defaultPage.vue'
import notLoggedPage from '../baseComponents/defaultNotLogPage.vue'

import notLogged from './notLogged'
import proUsers from './proUsers'
import bots from './bots'
import subBots from './subBots'
import { SET_SUBBOT, SET_BOT } from '../variables'

Vue.use(Router)

let router = new Router({
	routes: [
		{
			path: '*',
			name: 'notLoggedPage',
			redirect: '/login',
			component: notLoggedPage,
			children: [
				 ...notLogged
			]
		},
		{
			path: '*',
			name: 'default',
			component: DefaultPage,
			children: [
				...proUsers,
				...bots,
				...subBots
			],
			redirect: '/login'
		}
	]
})

router.beforeEach((to, from, next) => {
	let isLNotoggedPage = false
	for (let i = 0; i < notLogged.length; i++) {
		if (to.name === notLogged[i].name) {
			isLNotoggedPage = true
		}
	}

	if ((!store.getters.isAuthenticated || !store.getters.user) && !isLNotoggedPage) {
		next('Login?next=' + to.path)
	} else {
		if (to.params.botId) {
			store.dispatch(SET_BOT, to.params.botId)
				.then(() => {
					if (to.params && to.params.subBotId) {
						store.dispatch(SET_SUBBOT, to.params.subBotId)
							.then(() => {
								next()
							})
							.catch((err) => {
								next()
							})
					} else {
						next()
					}
				})
				.catch((err) => {
					next()
				})
		} else {
			next()
		}
	}
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js